export default __webpack_public_path__ + "static/media/minerva-transparent.db3983f6.png";